import { onSnapshot, query, where } from "firebase/firestore";
import { getRefs } from "../ref";
import { TYPES } from "./draft_dialog.type";

// ~~~~~~~~~ firebase ~~~~~~~~~~

// snap dialog edited
const draftDialogEditedSub = [];
export const snapDraftDialogEdited =
  ({ bailiffId }, callback) =>
  (dispatch) => {
    setDraftDialogEditedSuccess(dispatch, []);
    const cRef = getRefs().dialogEdited;
    const c0 = where("bailiff", "==", bailiffId);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        setDraftDialogEditedSuccess(dispatch, data);
      }
    });
    draftDialogEditedSub.push(unsub);
  };

export const unSnapDraftDialogEdited = (callback) => (dispatch) => {
  draftDialogEditedSub?.forEach((sub) => sub());
  draftDialogEditedSub.length = 0;
};

// ~~~~~~~~~ dispatch ~~~~~~~~~~
const setDraftDialogEditedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_EDITED,
    payload: data,
  });
};
